import styled from '@emotion/styled';

export const Container = styled.div`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[1]};
`;
